export default __webpack_public_path__ + "static/media/Quotes.13b4d2d9.svg";